import { styled } from '@mui/material/styles';

export const RootStyled = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: '#1c1c1c',
  minHeight: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  fontSize: 42,
  fontFamily: theme.typography.h4.fontFamily,
  '& svg': {
    fontSize: 80,
  },
}));
